import { defineComponent, type Component } from 'vue';
import { Tabs, TabPane } from 'ant-design-vue';
import SvgIcon from '@src/components/SvgIcon';
import PortalBanner from './components/PortalBanner';
import Password from './components/Password';
import MessageCode from './components/MessageCode';
import WechatQrcode from './components/WechatQrcode';
import PhoneRegister from './components/PhoneRegister';
import PhoneBind from './components/PhoneBind';
import './index.scss';

export default defineComponent({
    name: 'Login',
    setup() {
        /**
         * data
         */
        const activeKey = ref('微信扫码安全登录');
        const panelMap: Record<string, Component> = {
            微信扫码安全登录: WechatQrcode,
            手机号注册: PhoneRegister,
            手机号绑定: PhoneBind,
        };
        const tabMap: Record<string, Component> = {
            账号密码登录: Password,
            短信登录: MessageCode,
        };

        /**
         * methods
         */
        const setActiveKey = (key: string) => {
            activeKey.value = key;
        };

        return () => (
            <div class='login'>
                <div class='login-content g-flex'>
                    <div class='login-content__left g-flex-shrink-0'>
                        <PortalBanner />
                    </div>
                    <div class='login-content__right g-flex-1'>
                        {Object.keys(panelMap).includes(activeKey.value) ? (
                            h(panelMap[activeKey.value], {
                                onSetKey: setActiveKey,
                            })
                        ) : (
                            <div class='g-flex g-flex-1 g-flex-col g-items-center'>
                                <Tabs activeKey={activeKey.value} onUpdate:activeKey={(val: string) => (activeKey.value = val)}>
                                    {Object.entries(tabMap).map(([k, v]) => (
                                        <TabPane key={k} tab={k}>
                                            {h(v, {
                                                onSetKey: setActiveKey,
                                            })}
                                        </TabPane>
                                    ))}
                                </Tabs>
                                <div class='g-mt-[20px] g-w-full g-flex g-flex-col g-items-center'>
                                    <span class='text-divider g-w-full g-flex g-items-center g-justify-between'>其它登录方式</span>
                                    <span onClick={() => setActiveKey('微信扫码安全登录')}>
                                        <SvgIcon name='wechat' class='g-mt-[15px] g-cursor-pointer g-font-size-[38px]' />
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    },
});
